import { render, staticRenderFns } from "./SaleReqDetail.vue?vue&type=template&id=0e4eb4c8&scoped=true&"
import script from "./SaleReqDetail.vue?vue&type=script&lang=js&"
export * from "./SaleReqDetail.vue?vue&type=script&lang=js&"
import style0 from "./SaleReqDetail.vue?vue&type=style&index=0&id=0e4eb4c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4eb4c8",
  null
  
)

export default component.exports